module.exports = __webpack_public_path__ + "static/media/form.fb2e6b29.svg";